import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectBudgetGroupList from '@app/views/ProjectBudgetGroup/List';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectBudgetGroupList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
